import React, { useState } from 'react'
import { i18n } from '@tops/services'
import { theme } from '@tops/global_config'
import moment from 'moment'
import { ContainerAccount, Select, ConfirmationButton, PageTitle, Loader, MessageBanner, DashboardInput, StyledSwitch, UploadButton } from '@tops/components'
import { useDispatch, useSelector } from 'react-redux'
import { submitAccount } from '../../../actions/accounts.js'
import { getUpstreamTicketFile, getUpstreamTicketId } from '../../../actions/files'
import { Formik } from 'formik'
import Form from 'antd/lib/form/Form'
import * as yup from 'yup'
import { Divider } from 'antd'
import { toBase64 } from '@tops/utils'

const CreateAccount = (props) => {

  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  const [load, setLoad] = useState(false)
  const [validateError, setValidateError] = useState(false)
  const [upstreamTicket, setUpstreamTicket] = useState(null)

  const { Option, OptGroup } = Select;

  const accounts = useSelector(state => state.accounts)

  const dispatch = useDispatch()

  const selectOptions = [
    { 'name': 'Español', 'id': 0 },
    { 'name': 'Portugues', 'id': 1 },
    { 'name': 'Inglés', 'id': 2 },
  ]

  const hourZones = [
    { 'name': 'Midway, Samoa (UTC -11)', 'id': 1 },
    { 'name': 'Honolulu, Tahiti, Hawai, Johnston (UTC -10)', 'id': 2 },
    { 'name': 'Alaska, Nome, Sitka, Yakutat (UTC -9)', 'id': 3 },
    { 'name': 'Los Angeles, Tijuana, Vancouver, Pacific, Santa Isabel (UTC -8)', 'id': 4 },
    { 'name': 'Arizona, Cambridge Bay, Denver, Phoenix (UTC -7)', 'id': 5 },
    { 'name': 'Costa Rica, Mexico City, Monterrey, Galapagos, US Central (UTC -6)', 'id': 6 },
    { 'name': 'Bogota, Cancun, Lima, New York, Toronto (UTC -5)', 'id': 7 },
    { 'name': 'Asuncion, Caracas, La Paz, Santiago, Puerto Rico (UTC -4)', 'id': 8 },
    { 'name': 'Buenos Aires, Montevideo, Sao Paulo (UTC -3)', 'id': 9 },
    { 'name': 'Sur de Georgia, DeNoronha (UTC -2)', 'id': 10 },
    { 'name': 'Cabo Verde, Azores (UTC -1)', 'id': 11 },
    { 'name': 'Bissau, Dakar, Canarias, Reykjavik, Lisboa, Londres (UTC 0)', 'id': 12 },
    { 'name': 'Amsterdam, Andorra, Berlin, Madrid, Paris, Roma, Zurich (UTC 1)', 'id': 13 },
    { 'name': 'Cairo, Gaza, Jerusalem, Tel Aviv, Bucarest, Helsinki, Kiev (UTC 2)', 'id': 14 },
    { 'name': 'Baghdad, Kuwait, Estambul, Minsk, Moscu (UTC 3)', 'id': 15 },
    { 'name': 'Dubai, Samara (UTC 4)', 'id': 16 },
    { 'name': 'Maldivas (UTC 5)', 'id': 17 },
    { 'name': 'Dacca, Omsk, Chagos (UTC 6)', 'id': 18 },
    { 'name': 'Bangkok, Jakarta, Christmas (UTC 7)', 'id': 19 },
    { 'name': 'Hong Kong, Kuala Lumpur, Macao, Shanghai, Singapur (UTC 8)', 'id': 20 },
    { 'name': 'Seoul, Tokio, Palau (UTC 9)', 'id': 21 },
    { 'name': 'Brisbane, Canberra, Melbourne, Sydney, Tasmania, Queensland (UTC 10)', 'id': 22 },
    { 'name': 'Casey, Kosrae (UTC 11)', 'id': 23 },
    { 'name': 'Auckland, Fiji (UTC 12)', 'id': 24 },
    { 'name': 'Apia, Enderbury, Kanton, Tongatapu (UTC 13)', 'id': 25 },
    { 'name': 'Kirimati (UTC 14)', 'id': 26 }
  ]

  const onSubmit = async (values) => {
    await dispatch(submitAccount(values)).then(() => {
      setSuccess(true)
      setTimeout(() => setLoad(true), 1000)
      setTimeout(() => {
        props.history.goBack()
      }, 1000)
    },
      () => setError(true)
    )
  }

  const validationSchema = yup.object().shape({
    name: yup.string().trim().required(i18n('ERRORS').NAME_ERROR),
    wise_custom_name: yup.string().when('has_wise_access', {
      is: true,
      then: yup.string().max(50, "El nombre debe tener como máximo 50 caracteres").required(i18n('ERRORS').NAME_ERROR),
    }),
  })

  const initialValues = {
    name: "",
    language: 0,
    image_base64: "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",
    image_extension: "image/png",
    time_zone: null,
    has_wise_access: false,
    wise_custom_name: "",
    wise_custom_image: "",
    wise_custom_image_aux: [],
    upstream_ticket_id: null
  }

  if (accounts.isSubmitting) {
    return <Loader />
  }

  return (
    <>
      <PageTitle title={i18n('CREATE_ACCOUNT').LABEL} onBack={() => props.history.goBack()} />
      <MessageBanner visible={success} status="success" message={i18n('SUCCESS').CREATE_ACCOUNT} />
      <MessageBanner visible={error} status="error" message={accounts.error} onAccept={() => setError(false)} />
      <MessageBanner visible={validateError} status="error" message={i18n('ERRORS').VALIDATE_ERROR} />
      {load && <Loader />}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        validateOnChange={false}
        onSubmit={(values) => onSubmit(values)}
      >
        {({ handleChange, handleSubmit, setFieldValue, values, errors }) => (
          <>
            {Object.keys(errors).length > 0 ? setValidateError(true) : setValidateError(false)}
            <Form onFinish={handleSubmit}>
              <ContainerAccount width='500px' height='auto'>
                <DashboardInput label={i18n('ACCOUNT_NAME')} name="name" isRequired={true} error={errors.name} onChange={handleChange} horizontal="true" border="true" bold="true" width="300px" style={{ marginBottom: 20 }} />
                <Select label={i18n('LANGUAGE')} value={values.language} horizontal="true" width="300px" items={selectOptions} onChange={(e) => setFieldValue("language", e)} name="language" bold="true" />
                <Select label={i18n('HOUR_ZONE')} value={values.time_zone} horizontal="true" width="100%" items={hourZones} onChange={(e) => setFieldValue("time_zone", e)} name="time_zone" bold="true" style={{ flexFlow: 'column nowrap' }} />
                <Divider />
                <StyledSwitch id="editWiseAccess" onChange={() => setFieldValue('has_wise_access', !values.has_wise_access)} checked={values.has_wise_access}
                  label={i18n('WISE_NAME')} horizontal="true" style={{ fontWeight: 'bold' }} />
                {values.has_wise_access && <>
                  <DashboardInput label={i18n('WISE_NAME_INPUT')} name="wise_custom_name" isRequired={true} error={errors.wise_custom_name} onChange={handleChange} horizontal="true" border="true" bold="true" width="300px" />

                  <div style={{ display: "flex", marginTop: 10 }}>
                    <label style={{ color: theme.colors.darkGray, width: "180px" }}>Identificador</label>
                    <div style={{ display: "flex" }}>
                      <UploadButton hidePreview={true} withPreview={true} isImage={true} method="get" color={theme.colors.black} accept={".svg"} beforeUpload={async (file, _) => {
                        if (file.type !== 'image/svg+xml') {
                          alert(`${file.name} ${i18n('USER').REQUESTS.CREATE_EDIT.ERRORS.FILE_NOT_VALID}`);
                        } else {
                          let ticketId = upstreamTicket
                          let reader = new FileReader();
                          reader.readAsDataURL(file);
                          reader.onload = () => setLoad(true)
                          reader.onloadend = async () => {
                            if (ticketId === null) {
                              await dispatch(getUpstreamTicketId()).then((result) => {
                                setFieldValue('upstream_ticket_id', result.id)
                                setUpstreamTicket(result.id)
                                ticketId = result.id
                              })
                            }
                            let fileName = file.name.split('.')

                            await dispatch(getUpstreamTicketFile({
                              upstream_ticket_id: ticketId,
                              image_base64: await toBase64(file).then((res) => res.split(',')[1]),
                              image_extension: fileName[fileName.length - 1]
                            })).then((res) => {
                              setFieldValue("wise_custom_image", res.image_url)

                              file.url = reader.result
                              setFieldValue("wise_custom_image_aux", [file])
                            })
                            setLoad(false)
                          }
                        }
                        return false
                      }}
                        onRemove={(_) => {
                          setFieldValue("wise_custom_image_aux", [])
                          setFieldValue("wise_custom_image", null)
                        }} onChange={(_) => {
                          setFieldValue("wise_custom_image_aux", [])
                          setFieldValue("wise_custom_image", null)
                        }}
                      />
                      {values.wise_custom_image !== "" && <div style={{ borderLeft: `1px solid ${theme.colors.gray}`, paddingLeft: 15, marginLeft: 10 }}>
                        <p>Actual:</p>
                        <div style={{ width: 50, height: 50, borderRadius: "50%", background: theme.colors.user.wise.secondary, display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <img src={values.wise_custom_image} style={{ width: "100%", padding: 12, }} />
                        </div>
                      </div>}
                    </div>
                  </div>
                </>}
                <ConfirmationButton style={{ marginTop: 20, minWidth: 150 }}>{i18n('SAVE')}</ConfirmationButton>
              </ContainerAccount>
            </Form>
          </>
        )}
      </Formik>
    </>
  )
}

export default CreateAccount
